module.exports = __webpack_public_path__ + "static/iss_mi_logo_white-967c08fad313c6d9d888a0f6755da40b.png";